import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateReviews = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512.17 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#f2f2f2;}.d{fill:#ebf3ff;}.e{fill:#e6e6e6;}.f{fill:#fafcff;}.g{fill:#9ec5ff;}.h{fill:#b5c5ea;}.i{fill:#bdd5f4;}.j{fill:#dcebfe;}.k{fill:#152a61;}.l{fill:none;stroke:#b5c5ea;stroke-miterlimit:10;stroke-width:.91px;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "f",
				cx: 246.8,
				cy: 250,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "j",
						d: "M471.96,161h-131.49c-7.34,0-13.29-5.95-13.29-13.29V82.95c0-7.34,5.95-13.29,13.29-13.29h42.84c11.52-19.15,30.76-23.67,40.76-24.69,2.18-.22,3.45,2.4,1.93,3.97-7.04,7.3-10.11,14.52-11.19,20.72h57.16c7.34,0,13.29,5.95,13.29,13.29v64.76c0,7.34-5.95,13.29-13.29,13.29Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("polygon", {
							className: "h",
							points: "406.21 117.51 410.79 126.78 421.02 128.27 413.62 135.49 415.36 145.68 406.21 140.87 397.06 145.68 398.81 135.49 391.4 128.27 401.63 126.78 406.21 117.51"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							className: "h",
							points: "364.96 117.51 369.54 126.78 379.77 128.27 372.37 135.49 374.11 145.68 364.96 140.87 355.81 145.68 357.55 135.49 350.15 128.27 360.38 126.78 364.96 117.51"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							className: "h",
							points: "447.46 117.51 452.04 126.78 462.27 128.27 454.87 135.49 456.62 145.68 447.46 140.87 438.31 145.68 440.06 135.49 432.65 128.27 442.89 126.78 447.46 117.51"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							className: "h",
							points: "386.28 85.06 390.85 94.33 401.09 95.82 393.68 103.04 395.43 113.23 386.28 108.42 377.12 113.23 378.87 103.04 371.47 95.82 381.7 94.33 386.28 85.06"
						}),
						/* @__PURE__ */ _jsx("polygon", {
							className: "h",
							points: "428.81 85.06 433.38 94.33 443.62 95.82 436.21 103.04 437.96 113.23 428.81 108.42 419.65 113.23 421.4 103.04 414 95.82 424.23 94.33 428.81 85.06"
						})
					] }),
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M507.86,87.03c-5.78-5.74-15.11-5.74-20.9,0l-1.21,1.21-1.19-1.19c-5.23-6.3-14.58-7.17-20.88-1.93-6.3,5.23-7.17,14.58-1.93,20.88,.58,.7,1.23,1.35,1.93,1.93l22.08,22.08,22.11-22.11c5.73-5.78,5.73-15.1,0-20.88h-.01Z"
					})
				] }),
				/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M109.31,183.03H399.05c2.59,0,4.69,2.1,4.69,4.69v199.27H104.62V187.72c0-2.59,2.1-4.69,4.69-4.69Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
					className: "h",
					x: 134.9,
					y: 275.02,
					width: 78.4,
					height: 110.83,
					rx: 1.49,
					ry: 1.49
				}), /* @__PURE__ */ _jsx("circle", {
					className: "k",
					cx: 146.27,
					cy: 341.66,
					r: 3.81
				})] }),
				/* @__PURE__ */ _jsx("rect", {
					className: "h",
					x: 230.6,
					y: 275.02,
					width: 155.84,
					height: 76.23,
					rx: 1.74,
					ry: 1.74
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "c",
					points: "137.7 226.54 91.1 226.54 104.62 204.07 140.86 204.07 137.7 226.54"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M91.1,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "i",
					points: "184.3 226.54 137.7 226.54 140.86 204.02 185.06 204.07 184.3 226.54"
				}), /* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M137.7,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "c",
					points: "230.9 226.54 184.3 226.54 185.06 204.02 230.6 204.02 230.9 226.54"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M184.3,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "i",
					points: "277.5 226.54 230.9 226.54 230.6 204.07 277.5 204.07 277.5 226.54"
				}), /* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M230.9,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "c",
					points: "324.14 226.59 277.54 226.59 277.5 204.02 323.85 204.07 324.14 226.59"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M277.5,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "i",
					points: "370.69 226.54 324.14 226.59 323.85 204.07 367.99 204.07 370.69 226.54"
				}), /* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M324.09,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "c",
					points: "417.32 226.59 370.72 226.59 367.99 204.02 403.74 204.07 417.32 226.59"
				}), /* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M370.69,226.54h46.6v16.88c0,12.86-10.44,23.3-23.3,23.3h0c-12.86,0-23.3-10.44-23.3-23.3v-16.88h0Z"
				})] }),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 140.86,
					y1: 204.02,
					x2: 140.86,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 185.06,
					y1: 204.02,
					x2: 185.06,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 230.9,
					y1: 204.02,
					x2: 230.9,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 277.5,
					y1: 204.02,
					x2: 277.5,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 324.14,
					y1: 204.02,
					x2: 324.14,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "l",
					x1: 367.99,
					y1: 204.02,
					x2: 367.99,
					y2: 183.03
				}),
				/* @__PURE__ */ _jsx("rect", {
					className: "k",
					x: 83,
					y: 383.54,
					width: 378.62,
					height: 9.46,
					rx: 4.73,
					ry: 4.73
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M500.33,231.68c1.16,1.76-.3,4.06-2.39,3.76l-11.65-1.73c-.09-.01-.16-.05-.24-.07-6.2,6.21-14.77,10.05-24.24,10.05-18.93,0-34.27-15.34-34.27-34.27s15.34-34.27,34.27-34.27,34.27,15.34,34.27,34.27c0,4.36-.82,8.53-2.31,12.37,.02,.03,.04,.04,.06,.07l6.51,9.82Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M479.14,210.97c0-1.02-.55-1.94-1.43-2.45,.95-.55,1.54-1.61,1.39-2.78-.18-1.46-1.54-2.49-3-2.49h-9.14c.07-.18,.18-.44,.26-.66,.55-1.39,1.57-3.95,1.57-6.58,0-2.96-2.08-4.75-3.51-4.86-.88-.04-1.54,.51-1.68,1.5-.26,1.86-1.5,4.61-2.01,5.67-.15,.33-.33,.62-.58,.88-.84,.95-2.96,3.29-4.97,4.68,0,.07,.04,.18,.04,.26v17.51c0,.15-.04,.29-.04,.44,3.44,.99,6.54,1.46,9.94,1.46h7.79c1.35,0,2.63-.91,2.89-2.23,.22-1.1-.18-2.08-.91-2.74,1.24-.29,2.19-1.43,2.19-2.74,0-.84-.37-1.61-.99-2.12,1.24-.29,2.19-1.43,2.19-2.74Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "d",
					d: "M452.78,202.59h-6.1c-.84,0-1.54,.69-1.54,1.54v17.51c0,.84,.69,1.54,1.54,1.54h6.1c.84,0,1.54-.69,1.54-1.54v-17.47c0-.88-.66-1.57-1.54-1.57Z"
				})] })] })
			]
		})
	]
});
export default SvgEmptyStateReviews;
